import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EHealthAddressbook, EHealthService, SendMessageEHealth } from 'src/app/services/e-health.service';
import { PatientSearchResult, PatientService } from 'src/app/services/patient.service';
import { UserConfigService } from 'src/app/services/user-config.service';
import { debounceTime } from 'rxjs/operators';
import { EHealthMessageViewerDialogComponent } from '../e-health-messageviewer-dialog/e-health-messageviewer-dialog.component';
import { ImportConfirmDialogComponent } from '../import-confirm-dialog/import-confirm-dialog.component';
import { SendConfirmDialogComponent } from '../send-confirm-dialog/send-confirm-dialog.component';

export class AddressbookSearchResult {
  constructor(public result: any) {
  }
}

export class EHealthDestination {
  constructor(
    public name: string,
    public nihii: string,
    public ssin: string
  ){}
}

@Component({
  selector: 'app-e-health-message-dialog',
  templateUrl: './e-health-message-dialog.component.html',
  styleUrls: ['./e-health-message-dialog.component.scss']
})
export class EHealthMessageDialogComponent implements OnInit {

  destinataireControl = new UntypedFormControl();
  patientControl = new UntypedFormControl();
  destProposition: EHealthDestination[] = [];
  patientProposition: PatientSearchResult[] = [];
  sendmessage: string;
  displayedColumns: string[] = ['sender', 'title', 'date'];
  displayedSendColumns: string[] = ['document', 'recipient', 'patient', 'date', 'msg', 'delete'];
  selection = new SelectionModel<any>(true, []);
  okButtonLabel = 'Récupérer';
  okButtonAction = 'retrieve';
  selectedTab = 0;
  selectedSendTab = 0;

  constructor(public dialogRef: MatDialogRef<EHealthMessageDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public ehealth: EHealthService,
              public patient: PatientService,
              public dialog: MatDialog,
              public userConfig: UserConfigService) {
    console.log('Hello EHealthMessageDialogComponent Component');
    this.ehealth.listMessage().subscribe();
    this.ehealth.sendListMessage().subscribe();
    if (data.box)
    {
      if (data.box === 'in')
      {
        this.selectedTab = 0;
        this.selectedSendTab = 0;
      }
      if (data.box === 'out')
      {
        this.selectedTab = 1;
        this.selectedSendTab = 0;
      }
      this.setButtonLabels();
    }
  }

  ngOnInit(): void {
    this.destinataireControl.valueChanges.pipe(debounceTime(500)).subscribe(
      // Request ehealth for lastname
      value => {
        this.destProposition.length = 0;
        if (value.length > 3)
        {
          this.ehealth.search(value).subscribe(result => {
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < result.result.length; i++)
            {
              const aresult: any = result.result[i];
              this.destProposition.push(new EHealthDestination(aresult.lastName + ' ' + aresult.firstName, aresult.nihii, aresult.ssin));
            }
            console.log(this.destProposition);
          });
        }
      }
    );
    this.patientControl.valueChanges.pipe(debounceTime(500)).subscribe(
      // Request ehealth for lastname
      value => {
        this.patientProposition.length = 0;
        if (value.length > 3)
        {
          this.patient.search(value).subscribe(result => {
              this.patientProposition = result;
              console.log(this.patientProposition);
          });
        }
      }
    );
  }
  tabChanged(event: any)
  {
    this.selectedTab = event;
    this.setButtonLabels();
  }

  sendTabChanged(event: any)
  {
    this.selectedSendTab = event;
    this.setButtonLabels();
  }

  setButtonLabels()
  {
    switch (this.selectedTab)
    {
      case 0:
      {
        this.okButtonLabel = 'Récupérer';
        this.okButtonAction = 'retrieve';
      }
      break;
      case 1:
      {
        if (this.selectedSendTab === 0)
        {
          this.okButtonLabel = 'Envoyer tous les messages';
          this.okButtonAction = 'sendall';
        }
        if (this.selectedSendTab === 1)
        {
          this.okButtonLabel = 'Envoyer ce message direct';
          this.okButtonAction = 'send';
        }
      }
      break;
    }
  }

  displayDestinataire(user?: EHealthDestination): string | undefined {
    return user ? user.name : undefined;
  }

  displayPatient(patient?: PatientSearchResult): string | undefined {
    return patient ? patient.firstname + ' ' + patient.lastname : undefined;
  }

  getMessageTitle(message)
  {
    return (message.id === null) ? message.title : message.document.title;
  }

  selectMessage(messageid)
  {
    console.log(messageid);
    this.ehealth.message(messageid).subscribe( result => {
      if (result.result !== false)
      {
        // View content
        const dialogRef = this.dialog.open(EHealthMessageViewerDialogComponent, {
          data: {
            message: result.message,
            result: result.result
          }
        });
        dialogRef.afterClosed().subscribe(dialogresult => {
          if (dialogresult === 'delete')
          {
            // reload messages
            this.ehealth.listMessage().subscribe();
          }
        });
      }
    });
  }

  selectSendMessage(messageid)
  {
    console.log('Send message id : ' + messageid);
/*    this.ehealth.message(messageid).subscribe( result => {
      console.log(result);
      // View content
      let dialogRef = this.dialog.open(EHealthMessageviewerDialogComponent, {
        data: {
          message:result.message,
          result:result.result
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result == 'delete')
        {
          // reload messages
          this.ehealth.listMessage().subscribe();
        }
      });
    });*/
  }

  okButtonClicked()
  {
    if (this.okButtonAction === 'retrieve')
    {
      this.confirmImport();
    }
    if (this.okButtonAction === 'send')
    {
      this.confirmSend();
    }
    if (this.okButtonAction === 'sendall')
    {
    this.confirmSendAll();
    }
  }

  confirmImport()
  {
    const dialogRef = this.dialog.open(ImportConfirmDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'import')
      {
        console.log('Start Import All');
        this.ehealth.startmessageretrieving();
      }
    });
  }

  confirmSend()
  {
    const dialogRef = this.dialog.open(SendConfirmDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'send')
      {
//        console.log('send message',this.patientControl.value,this.destinataireControl.value);
        const message = new SendMessageEHealth(
          new EHealthAddressbook(this.destinataireControl.value),
          this.patientControl.value,
          this.sendmessage
        );
        this.ehealth.sendMessage(message);
      }
    });
  }

  confirmSendAll()
  {
    const dialogRef = this.dialog.open(SendConfirmDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'send')
      {
        this.ehealth.sendAllMessages();
      }
    });
  }

  getSendMessageType(message)
  {
    if (message.Key === 'stvaast_rapportconsultation')
    {
      return 'Rapport de consultation';
    }
    return 'Pas supporté.';
  }

  getSendMessageError(message)
  {
    if (typeof (message.lastNotification) !== 'undefined')
    {
      if (message.lastNotification.properties.SendStatus === 'Failed')
      {
        return message.lastNotification.properties.SendDateTime + ' : ' + message.lastNotification.properties.SendStatusInfo;
      }
    }
    return null;
  }

  removeMessageFromQueue(message)
  {
    const dialogRef = this.dialog.open(SendConfirmDialogComponent, {
      data: {
        title: 'Confirmation de suppression',
        message: 'Voulez-vous supprimer ce message ?',
        sendbutton: 'Supprimer',
        sendstatus: 'remove'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'remove')
      {
        this.ehealth.sendDeleteMessage(message.ID).subscribe(deleteresult => {
          // Reload message list
          this.ehealth.sendListMessage().subscribe();
        });
      }
    });
  }
}
